<template>
  <div
    class="product"
    @mouseenter="image_1 = false"
    @mouseleave="image_1 = true"
  >
    <a :href="get_product_page_url" target="_blank">
      <div v-if="cleaned_product.confidence">
        <template v-if="cleaned_product.confidence >= 90">
          &mdash;VERY HIGH&mdash;
        </template>
        <template v-else-if="cleaned_product.confidence >= 70">
          &mdash;HIGH&mdash;
        </template>
      </div>

      <img
        v-show="image_1 || !cleaned_product.img_2"
        :src="cleaned_product.img_1"
      />
      <img
        v-show="!image_1 && cleaned_product.img_2"
        :src="cleaned_product.img_2"
      />

      <div
        v-if="
          !$root.isBottomType &&
          cleaned_product.true_size &&
          cleaned_product.true_size !== $root.online_fitting.fitted_size
        "
        class="confidence"
      >
        Courtney recommends a {{ cleaned_product.true_size }} for this product
      </div>
      <div
        v-else-if="!$root.isBottomType && cleaned_product.fitted_by"
        class="confidence"
      >
        Courtney has fitted someone with your exact same size and shape with
        this bra
      </div>

      <h4>{{ cleaned_product.title }}</h4>

      <div>${{ cleaned_product.price.toFixed(2) }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    product: {
      type: Object,
      required: true,
    },
    search_by_size: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    get_product_page_url() {
      return `https://bosombesties.com/products/${this.cleaned_product.handle}`;
    },
  },
  data() {
    return {
      cleaned_product: {},
      image_1: true,
    };
  },
  created() {
    if (!this.search_by_size) {
      this.cleaned_product = this.product;
    } else {
      const fitted_by = false;
      const handle = this.product.handle;
      let img_1 = null;
      try {
        img_1 = this.product.variants[0].image.src;
      } catch (e) {}
      let img_2 = null;
      try {
        img_2 = this.product.variants[1].image.src;
      } catch (e) {}
      const price = Number(this.product.variants[0].price);
      const title = this.product.title;

      this.cleaned_product = {
        fitted_by,
        handle,
        img_1,
        img_2,
        price,
        title,
      };
    }
  },
};
</script>

<style lang="less" scoped>
.product {
  display: inline-block;
  position: relative;
  vertical-align: top;
  margin: 15px;
  padding: 15px;
  width: 270px;

  &:hover {
    box-shadow: 0px 0px 3px 1px rgba(250, 31, 151, 0.75);
  }

  a {
    display: inline-block;
    text-decoration: none;
    position: relative;
  }

  img {
    width: 270px;
    height: 300px;
    object-fit: cover;
  }

  h4 {
    margin-top: 0;
  }

  .confidence {
    padding: 5px;
    color: white;
    background-color: rgba(250, 31, 151, 0.5);
    position: absolute;
    bottom: ~"calc(100% - 300px)";
    font-weight: bold;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
